import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { mainBodyList, mainBodyDetail } from '@/api/gucangSales/customerCenter'
import type { MainBodyParams } from '@/typings/api/customerCenter'
import { mainBodyStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'


const __default__ = { name: 'DcCosFbuMainBody' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const queryForm = reactive<MainBodyParams>({ customer: {} })
const columns = computed(() => [
  { title: '主客户代码', dataIndex: ['customer', 'customerNumber'] },
  { title: '客户名称', dataIndex: ['customer', 'customerName'] },
  { title: '客户ID', dataIndex: ['customer', 'cosId'] },
  { title: '子客户代码', dataIndex: 'customerCode' },
  { title: '账户编号', dataIndex: 'accountCode', headerQuestion: '取值来源：ark签约主体管理-账户编号' },
  { title: '签约主体', dataIndex: 'signBodyName', headerQuestion: '取值来源：ark签约主体管理-主体名称' },
  { title: '服务主体', dataIndex: 'serviceBodyName', headerQuestion: '取值来源：ark签约主体管理-服务主体' },
  {
    title: '主体联系人',
    dataIndex: 'contactName',
    cosType: 'mask',
    headerQuestion: '取值来源：ark签约主体管理-联系人姓名',
    minWidth: 130
  },
  {
    title: '主体手机号码',
    dataIndex: 'phoneNumber',
    cosType: 'mask',
    headerQuestion: '取值来源：ark签约主体管理-联系电话',
    width: 145
  },
  {
    title: '可用余额',
    dataIndex: 'signBodyBalanceList',
    headerQuestion: '取值来源：ark签约主体管理-可用余额',
    width: 200
  },
  { title: '信用额度', dataIndex: 'totalQuota', headerQuestion: '取值来源：ark签约主体管理-信用额度' },
  { title: '总可用额度', dataIndex: 'allTotal', headerQuestion: '取值来源：ark签约主体管理-总可用额度', minWidth: 130 },
  { title: '出账周期', dataIndex: 'accountCycleTypeStr', headerQuestion: '取值来源：ark签约主体管理-出账周期' },
  { title: '对账周期', dataIndex: 'reconciliationCycleTypeStr', headerQuestion: '取值来源：ark签约主体管理-对账周期' },
  { title: '签约业务', dataIndex: 'signBusinessTypeStr', headerQuestion: '取值来源：ark签约主体管理-签约业务' },
  {
    title: '已签约业务',
    dataIndex: 'contractedBusinessStr',
    headerQuestion: '取值来源：ark签约主体管理-已签约业务',
    minWidth: 130
  },
  {
    title: '注册国家/区域',
    dataIndex: 'registerAreaCode',
    headerQuestion: '取值来源：ark签约主体管理-注册国家/区域',
    width: 160
  },
  {
    title: '主体类别',
    dataIndex: 'type',
    dicData: [
      { value: 'C101', label: '个人' },
      { value: 'C102', label: '公司' }
    ],
    headerQuestion: '取值来源：ark签约主体管理-主体类别'
  },
  {
    title: '状态',
    dataIndex: 'signBodyStatus',
    headerQuestion: '取值来源：ark签约主体管理-状态',
    dicData: mainBodyStatusEnum
  },
  { title: '审核时间', dataIndex: 'examineTime', headerQuestion: '取值来源：ark签约主体管理-审核时间', width: 190 },
  {
    title: '客户负责人',
    dataIndex: ['customer', 'sellerName'],
    headerQuestion: '取值来源：ark签约主体管理-销售代表',
    minWidth: 130
  },
  { title: '负责人区域', dataIndex: ['customer', 'sellerRegion'], key: 'sellerRegion', minWidth: 190 }
])

// 检测 URL 是否带有查询参数，有则使用
const route = useRoute()
const queryCustomerCode = computed(() => route.query.customerCode as string)
onBeforeMount(() => {
  if (queryCustomerCode.value) queryForm.customerCode = queryCustomerCode.value
})

const getList = (queryForm: MainBodyParams, callBack: (res: any) => void) => {
  mainBodyList(queryForm).then((res) => {
    callBack(res)
  })
}

// 获取详情信息
const showMask = (record: any, callBack: (res: any) => void) => {
  mainBodyDetail({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[8] || (_cache[8] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosFbuMainBody"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "主客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customer.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.customer.customerNumber) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customer.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customer.customerName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customer.cosId,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customer.cosId) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "签约主体" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.signBodyName,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.signBodyName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "子客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.customerCode) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "账户编号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.accountCode,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.accountCode) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "组织部门" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_fbu",
                        ids: queryForm.customer.sellerRegionList,
                        "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.customer.sellerRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.customer.seller,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.customer.seller) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_fbu",
                taskType: "212",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'fbu_main_body_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text }) => [
              (column.dataIndex === 'signBodyBalanceList')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(text?.map((item) => `${item.currencyCode}：${item.quota}`).join('、')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.key === 'sellerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 1,
                    appId: "cos_fbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})